import { Br } from "@/components/molecules/Br";
import { faHashtag } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import bgMission from "/public/bg-mission.webp";
import leadCredo from "/public/lead-credo.svg";
import leadMission from "/public/lead-mission.svg";

const credos = [
  {
    id: "Compassion",
    title: "思いやりという創造力",
    body: "相手に寄り添う姿勢こそ、システム構築に必要なクリエイティブの源",
  },
  {
    id: "User Experience",
    title: "わたしもユーザー",
    body: "技術は大事。だけど「使えるシステム」はいつもユーザーファースト",
  },
  {
    id: "Self Discovery",
    title: "新しい自分に出会う",
    body: "新たな「なにか」を知ることは、新たな「私」と出会うこと",
  },
  {
    id: "Heart to Heart",
    title: "チームと本音で向かい合う",
    body: "助け合うにはひとりでため込まず、頼る勇気と責任感が大事",
  },
  {
    id: "Self Discipline",
    title: "自由な社風は自己規律から",
    body: "言われたことに応えるだけでなく、自分のゴールを自分で定める",
  },
  {
    id: "Relationship",
    title: "わたしたちは仲間",
    body: "新しい挑戦には、失敗がつきもの。だけど助けてくれる仲間がいる",
  },
  {
    id: "Teamwork",
    title: "最後は人が大事",
    body: "ともに影響し合い成長する仲間。互いを尊重するのが、私たちのカタチ",
  },
];

export const AboutMission = (props) => {
  return (
    <div id="about" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl px-6 sm:px-8 md:px-12 xl:px-0">
        <div className="relative z-10">
          <h3 className="font-bold text-pri fluid-text-[16px,22px] ">About</h3>
          <h2 className="relative z-0 mx-auto mt-6 flex aspect-5.67/1 w-full items-center justify-center md:mt-10">
            <Image
              src={leadMission}
              alt="ToccaSystems's Product"
              quality={50}
              layout="fill"
              objectFit="cover"
            />
          </h2>
          <div className="relative mt-6 flex flex-col items-start justify-between gap-4 text-txt-base md:mt-12 md:flex-row md:items-center">
            <h3 className="relative aspect-8.66/1 w-full max-w-[256px]  md:max-w-[288px] lg:max-w-[416px] ">
              <Image
                src={leadCredo}
                alt="システムを軸にした成長運用"
                quality={80}
                layout="fill"
                objectFit="cover"
              />
            </h3>
            <h4 className="w-auto font-bold leading-snug text-txt-base fluid-text-[14px,20px] lg:w-[544px]">
              ToccaSystemsでは、わたしたち自身の成長のために
              <Br tbpc />
              7つの言葉を大切にしています。
            </h4>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-4 md:mt-12 md:gap-8">
            {credos.map((credo) => (
              <div className="col-span-1 space-y-1" key={credo.index}>
                <h4 className="font-bold text-ter fluid-text-[14px,16px]">
                  <FontAwesomeIcon icon={faHashtag} className="mr-2" />
                  {credo.id}
                </h4>
                <h3 className="font-bold text-pri fluid-text-[18px,32px]">
                  {credo.title}
                </h3>
                <p className="font-bold text-txt-base fluid-text-[12px,16px]">
                  {credo.body}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="absolute top-1/2 left-1/2 z-0 h-auto -translate-y-1/2 -translate-x-1/2 fluid-width-[300px,624px]">
          <Image src={bgMission} alt="ToccaSystems's Product" quality={50} />
        </div>
      </div>
    </div>
  );
};
